import { NativeDateAdapter } from '@angular/material/core';

export class MaterialDateAdapter extends NativeDateAdapter {
    getFirstDayOfWeek(): number {
        return 1;
    }
}
